module.exports = __webpack_public_path__ + "img/statment-pay.9b6568f7.png";